import { gql } from '@apollo/client';

export const FETCH_INTERACTIONS = gql`
query LatestInteractions($unifiedContactIds: [ID!]!) {
    latestInteractions(unifiedContactIds: $unifiedContactIds) {
      unifiedContactId
      subject
      kind
      whenHappened
    }
  }
`;

export const UPDATE_CONTACT_VISIBILITY = gql`
mutation UpdateUnifiedContact($updateUnifiedContactInput: UpdateUnifiedContactInput!) {
    updateUnifiedContact(input: $updateUnifiedContactInput) {
        unifiedContact {
            id
            visible
          }
        errors {
            path
            message
        }
    }
}
`;
